import { createAsyncAction } from "../helpers";

export const getShopsAsyncAction = createAsyncAction("GET_SHOPS");

export const getShopAsyncAction = createAsyncAction("GET_SHOP");

export const updateShopStatusAsyncAction = createAsyncAction(
	"UPDATE_SHOP_STATUS"
);

export const exportShopDataAsyncAction = createAsyncAction("EXPORT_SHOPS");
